"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationFuehrungsrinnenFilter = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const ConfigurationUnion_1 = require("../ConfigurationUnion");
/**
 * Filter for Fuehrungsrinnen and Montage Sets
 */
class ConfigurationFuehrungsrinnenFilter {
    /**
     * Filter the given Fuehrungsrinnen list and only return Fuehrungsrinnen that are compatible with
     * the given Kette in config.
     */
    static filterFuehrungsrinnenByConfig({ fuehrungsrinneList, configModel, }) {
        const { type, config } = (0, ConfigurationUnion_1.asTypedConfigurationUnion)(configModel);
        switch (type) {
            case 'Empty':
            case 'Espool':
            case 'EspoolChild':
                return [];
            case 'Kette': {
                const kette = (0, echain_shared_articles_oo_1.A)(config.Kette);
                return echain_shared_articles_oo_1.FuehrungsrinnenFilter.filterFuehrungsrinnenByKette(fuehrungsrinneList, kette);
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    static filterMontageSetsByFuehrungsrinneConfig({ montageSetList, fuehrungsrinne, configModel, }) {
        const { type, config } = (0, ConfigurationUnion_1.asTypedConfigurationUnion)(configModel);
        switch (type) {
            case 'Empty':
            case 'Espool':
            case 'EspoolChild':
                return [];
            case 'Kette':
                return echain_shared_articles_oo_1.FuehrungsrinnenFilter.filterMontageSetsByFuehrungsrinneKette(montageSetList, fuehrungsrinne, (0, echain_shared_articles_oo_1.A)(config.Kette));
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
}
exports.ConfigurationFuehrungsrinnenFilter = ConfigurationFuehrungsrinnenFilter;
//# sourceMappingURL=ConfigurationFuehrungsrinnenFilter.js.map